export default "//yastatic.net/s3/distribution/pythia/frontend/_/0319023fb3e78eb5d5d264471151cd93.png";